<div class="scheduled-rebalances-list-component" id="scheduled-rebalances-list-component">
    <div>
        <div style="margin-bottom: 10px;">
            <strong> {{rowCount + ' scheduled rebalances'}}</strong><span id="scheduledRebalancesToolTipIcon" class="infoIcon" calltoaction [calltoactionTemplate]="scheduledRebalancesToolTipIcon"></span>
            <span><img src="/assets/images/lighting_bolt_smartfilter.png" style="vertical-align: middle;">&nbsp;means that the portfolio is included because of the rebalance's auto filter criteria</span>
            <div class="right">
                <button class="btn btn-medium-secondary" (click)="onIncludeInaScheduledRebalance()">Include in a scheduled rebalance</button>
            </div>
        </div>

    </div>
    <irb-inventory-grid
            class="scheduled-rebalances-list-grid-ag"
            [style.width]="'100%'"
            [style.height]="this.defaultGridHeights.height"
            [style.minHeight]="this.defaultGridHeights.minHeight"
            [style.maxHeight]="this.defaultGridHeights.maxHeight"
            [domLayout]="this.defaultGridHeights.domLayout"
            [showSideBar]="false"
            [gridOptions]="gridOptions"
            [rowData]="this.scheduledBalances"
            [frameworkComponents]='frameworkComponents'
            (gridReady)="onGridReady($event)"></irb-inventory-grid>
</div>
<ng-template #scheduledRebalancesToolTipIcon>
    <div>Scheduled rebalances are not editable for multiple portfolios. You can edit the portfolio's included rebalances on the individual portfolio detail screen.
    </div>
</ng-template>
